import { useFormContext } from 'react-hook-form';

import { type AdminProctorDetailsFormInput } from './schema';

function useAdminProctorDetailsForm() {
  const context = useFormContext<AdminProctorDetailsFormInput>();

  if (!context) {
    throw new Error(
      'useAdminProctorDetailsForm must be used within an AdminProctorDetailsFormProvider',
    );
  }

  return context;
}

export { useAdminProctorDetailsForm };
